module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Hand-1e14ad7f91c87cf8456d614488343e73.png";